import React from "react";
import { formatarReais } from "../lib/pagamentoPartes";

// Complemento do pagamento no detalhe do pedido, que as formas agrupadas não
// mostram: o troco e, no iFood, como o cliente pagou lá dentro ("Cartão de
// crédito — pago pelo iFood", "Dinheiro — cobrar na entrega").

const troco = (pagoCom, valor) =>
  `(troco ${formatarReais(Math.max(0, Number(pagoCom) - Number(valor || 0)))} — paga com ${formatarReais(pagoCom)})`;

export default function DetalhePagamentoExtra({ pedido, nomePagamento }) {
  const brutas = Array.isArray(pedido?.pagamentos) ? pedido.pagamentos : [];
  const ifood = (pedido?.pagamentoPartes || []).some((p) => p.chave === "ifood");
  const dividido = String(pedido?.formaPagamento || "").toLowerCase() === "multiplo";
  const linhas = [];
  if (ifood) {
    brutas.forEach((pg) => linhas.push(`${pg.label || nomePagamento(pg.method)} ${formatarReais(pg.amount)}`));
  }
  if (dividido) {
    brutas.filter((pg) => pg.troco_precisa && pg.troco_valor).forEach((pg) =>
      linhas.push(`${pg.label || nomePagamento(pg.method)} ${troco(pg.troco_valor, pg.amount)}`));
  } else if (pedido?.troco?.precisa && pedido.troco.valor) {
    linhas.push(troco(pedido.troco.valor, pedido.total));
  }
  if (!linhas.length) return null;
  return (
    <div className="space-y-0.5">
      {linhas.map((l, i) => (
        <div key={i} className={`text-xs ${ifood && i < brutas.length ? "text-muted-foreground" : "text-green-600"}`}>{l}</div>
      ))}
    </div>
  );
}
